import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { SingletonRequest } from 'shared/api/lib'
import type { EntitiesStore } from 'entities/EntitiesExport'
import { SmartView } from 'entities/SmartViews/model/SmartView'
import { type IResponseSmartView } from 'entities/SmartViews/api/types'
import { SmartViewsApi } from 'entities/SmartViews/api/smartViews'

export class SmartViewsStore {
  public itemsMap: Map<number, SmartView> = new Map()

  constructor(private _entities: EntitiesStore) {
    makeAutoObservable(this)
  }

  private _fetchSmartViews = async () => {
    try {
      await this._entities.featureFlagsStore.fetchFeatureFlags()

      if (!this._entities.featureFlagsStore.smart_views) return

      const response = await SmartViewsApi.getSmartViews()
      const data = response.data

      data.forEach((item) => {
        this.addItem(item)
      })
    } catch (e) {
      logger.error(e)
    }
  }

  fetchSmartViews = new SingletonRequest(this._fetchSmartViews).request

  getItemAsync = async (id: number) => {
    try {
      const item = this.getItem(id)

      if (item) return item

      const response = await SmartViewsApi.getSmartViewById(id)

      return this.addItem(response.data)
    } catch (e) {
      logger.error(e)
    }
  }

  getItem = (id: number | null) => {
    if (!id) return

    return this.itemsMap.get(id)
  }

  addItem = (item: IResponseSmartView) => {
    this.itemsMap.set(item.id, new SmartView(item, this._entities))

    return this.getItem(item.id)
  }

  deleteItem = (id: number) => {
    this.itemsMap.delete(id)
  }

  updateFavorite = async (item: SmartView, status: boolean) => {
    if (item.is_favorite === status) return

    await SmartViewsApi.updateSmartViewFavorite({
      id: item.id,
      favorite: status,
    })

    runInAction(() => {
      item.is_favorite = status
    })
  }

  get itemsList() {
    return Array.from(this.itemsMap.values())
  }
}
